import React, { useState } from 'react';
import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';
import { Dropdown } from 'antd';
import Menu from 'components/ui/Menu';
import { MdKeyboardArrowDown as DownArrowIcon } from 'react-icons/md';
import { MdCheck as CheckIcon } from 'react-icons/md';

const StyledContainer = styled.div`
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;
  background-color: white;
`;

const StyledDropdownContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${colors.STATE_BLUE};
  background: #dfe8ff;
  height: 40px;
  border-radius: ${(props) => (props.isOpen ? '20px 20px 0 0' : '50px')};
  padding: 15px;
  font-weight: 500;
  font-size: 16px;
`;

const StyledDropdown = styled(Dropdown)``;

const StyledMenu = styled(Menu)`
  padding: 0;
  border: 1px solid ${colors.LIGHT_PERIWINKLE};
  border-radius: 0;
  margin-top: -5px;
  box-shadow: none;
`;

const StyledMenuItem = styled(Menu.Item)`
  color: ${(props) => (props.active ? colors.STATE_BLUE : colors.SLATE_GREY)};
  &:hover {
    color: ${colors.STATE_BLUE};
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledDownArrowIcon = styled(DownArrowIcon)`
  transition-duration: 0.18s;
  transform: ${(props) => (props.arrowPointsUp ? 'rotate(180deg)' : 'rotate(0)')};
`;

const StyledCheckIcon = styled(CheckIcon)`
  color: ${colors.STATE_BLUE};
`;

const MobileNavDropdown = ({ tabs, currentValue, onChange, children }) => {
  const [visible, setVisible] = useState(false);

  function handleMenuClick(event) {
    const value = event.item.props.value;
    setVisible(false);
    if (onChange) onChange(value);
  }

  // hook into dropdown for click outside
  const onVisibleChange = (isVisible) => {
    setVisible(isVisible);
  };

  const handleClick = () => {
    setVisible(!visible);
  };

  const menu = (
    <StyledMenu onClick={handleMenuClick} selectable>
      {tabs.map((tab, key) => {
        const isSelected = tab.value === currentValue;
        const icon = isSelected ? <StyledCheckIcon /> : null;
        return (
          <StyledMenuItem key={key} value={tab.value} active={isSelected}>
            {tab.label}
            {icon}
          </StyledMenuItem>
        );
      })}
    </StyledMenu>
  );

  return (
    <StyledContainer>
      <StyledDropdown
        overlay={menu}
        trigger={['click']}
        visible={visible}
        onVisibleChange={onVisibleChange}
      >
        <StyledDropdownContainer onClick={handleClick} isOpen={visible}>
          {currentValue.label}
          <StyledDownArrowIcon size={26} arrowPointsUp={visible} />
        </StyledDropdownContainer>
      </StyledDropdown>
    </StyledContainer>
  );
};

export default MobileNavDropdown;
